import { render, staticRenderFns } from "./Investments.vue?vue&type=template&id=e0e6c394&scoped=true"
import script from "./_Investments.js?vue&type=script&lang=js&external"
export * from "./_Investments.js?vue&type=script&lang=js&external"
import style0 from "./_Investments.css?vue&type=style&index=0&id=e0e6c394&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e6c394",
  null
  
)

export default component.exports